import $i18n from 'panda-i18n';
/**
 * @author: zengnanq
 * @description: 分拨常量
 */

/**
 * @description 分拨状态
 */
const ALLOCATE_ORDER_STATUS = [
  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'PW',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'AI',
  },

  {
    label: $i18n.get({ id: 'GroupPackageInProgress.four_px', dm: '组包中' }),
    value: 'PI',
  },

  {
    label: $i18n.get({ id: '31255237218144256.CNTM', dm: '已组包' }),
    value: 'PC',
  },

  {
    label: $i18n.get({ id: 'Shipped.four_px', dm: '已发运' }),
    value: 'DC',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'CC',
  },
];

// 分拨-包裹订单类型
const ALLOCATE_TASK_TYPE = [
  {
    label: $i18n.get({ id: 'WarehouseSorting', dm: '仓发分拣' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'ExternalSorting', dm: '外部分拣' }),
    value: 'O',
  },
];

// 单号类型
const ALLOCATE_NO_TYPE = [
  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' }),
    value: 'refNo',
  },

  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNo',
  },

  {
    label: $i18n.get({ id: 'PTJYDH.PlatformTransactionNumber.four_px', dm: '平台交易单号' }),
    value: 'saleNo',
  },
];

// 分拨-组包作业单-列表状态
const GROUP_LIST_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'GroupPackageInProgress.four_px', dm: '组包中' }),
    value: 'PI',
  },

  {
    label: $i18n.get({ id: '31255237218144256.CNTM', dm: '已组包' }),
    value: 'PC',
  },
];

// 分拨-分拣作业单-列表状态
const ASSORT_LIST_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'txt_status_picking', dm: '进行中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'picture_completed', dm: '已完成' }),
    value: 'C',
  },
];

// 分拨-发运作业单-列表状态
const DELIVERY_LIST_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'txt_status_picking', dm: '进行中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'picture_completed', dm: '已完成' }),
    value: 'C',
  },
];

// 发运-笼车状态
const SHIPPED_STATUS = [
  {
    label: $i18n.get({ id: 'Shipped.four_px', dm: '已发货' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Unshipped.four_px', dm: '未发货' }),
    value: 'N',
  },
];

// 出库时间类型
const ALLOCATE_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'ReviewTime.four_px', dm: '审核时间' }),
    value: 'approveTime',
  },

  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },
];

// 退件步骤

const RETURN_STEPLIST = [
  {
    label: $i18n.get({ id: 'ScanningTurnoverBox.four_px', dm: '扫描周转箱' }),
    value: 'CQ0001',
  },

  {
    label: $i18n.get({ id: 'ScanRMA', dm: '扫描RMA' }),
    value: 'CQ0002',
  },

  {
    label: $i18n.get({ id: 'ScanBarCode', dm: '扫描条码' }),
    value: 'CQ0003',
  },

  {
    label: $i18n.get({ id: 'CompleteRMA', dm: '完成RMA' }),
    value: 'CQ0004',
  },

  {
    label: $i18n.get({ id: 'LabelPrinting.four_px', dm: '标签打印' }),
    value: 'CQ0005',
  },

  {
    label: $i18n.get({ id: 'ScanShelfContainers', dm: '扫描上架容器' }),
    value: 'CQ0006',
  },

  {
    label: $i18n.get({ id: 'DeleteSKU', dm: '删除SKU' }),
    value: 'CQ0007',
  },

  {
    label: $i18n.get({ id: 'UpdateSKU', dm: '更新SKU' }),
    value: 'CQ0008',
  },

  {
    label: $i18n.get({ id: 'CloseTheBox', dm: '关箱' }),
    value: 'CQ00009',
  },

  {
    label: $i18n.get({ id: 'AbnormalFinish', dm: '异常完结' }),
    value: 'CQ00010',
  },
];

// 收货作业步骤 returnService
const RETURNSERVICE_LIST_TER = [
  {
    label: $i18n.get({ id: 'ScanLogisticsNumber', dm: '扫描物流单号' }),
    value: 'RR0001',
  },

  {
    label: $i18n.get({ id: 'ScanningTurnoverBox.four_px', dm: '扫描周转箱' }),
    value: 'RR0002',
  },

  {
    label: $i18n.get({ id: 'ConfirmReceipt', dm: '确认收货' }),
    value: 'RR0003',
  },

  {
    label: $i18n.get({ id: 'CloseTheBoxEndOfReceipt_817475449', dm: '关箱（完结收货）' }),
    value: 'RR0004',
  },
];

const RETURNSTEP_LIST_DATA = [
  {
    label: $i18n.get({ id: 'ScanningTurnoverBox.four_px', dm: '扫描周转箱' }),
    value: 'CQ0001',
  },

  {
    label: $i18n.get({ id: 'ScanRMA', dm: '扫描RMA' }),
    value: 'CQ0002',
  },

  {
    label: $i18n.get({ id: 'ScanBarCode', dm: '扫描条码' }),
    value: 'CQ0003',
  },

  {
    label: $i18n.get({ id: 'CompleteRMA', dm: '完成RMA' }),
    value: 'CQ0004',
  },

  {
    label: $i18n.get({ id: 'LabelPrinting.four_px', dm: '标签打印' }),
    value: 'CQ0005',
  },

  {
    label: $i18n.get({ id: 'CloseTheBoxEndOfReceipt_817475449', dm: '关箱（完结收货）' }),
    value: 'CQ0006',
  },
];

const ALLOCATE_URL = '/allocate';

export {
  ALLOCATE_TIME_TYPE,
  ALLOCATE_ORDER_STATUS,
  ASSORT_LIST_STATUS,
  ALLOCATE_TASK_TYPE,
  ALLOCATE_URL,
  ALLOCATE_NO_TYPE,
  GROUP_LIST_STATUS,
  DELIVERY_LIST_STATUS,
  SHIPPED_STATUS,
  RETURN_STEPLIST,
  RETURNSERVICE_LIST_TER,
  RETURNSTEP_LIST_DATA,
};
